var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":this.divid}},[(_vm.viewer)?_c('div',_vm._l((_vm.sources),function(source){return _c('source-component',{key:source.id,attrs:{"sourceId":source.id,"footer":{ title: _vm.onesource ? _vm.footertitle : undefined }}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }